module.exports = __webpack_public_path__ + "static/media/front desk.e1748bd5.svg";